import * as React from "react";
import { styled, css } from "@lib/components";
import { MobxComponent } from "../../../../mobx/components/index";
import { withTranslation, WithTranslation } from "react-i18next";
import { FaBell } from "react-icons/fa";
import { inject, observer } from "mobx-react";
import { keyframes } from "@lib/components";
import { shadeAlternate } from "@lib/components";
import { DropDown } from "@lib/components";
import { NotificationsList } from "./list";
import { ConnectionIndicatorCircle } from "@lib/components";

interface Props extends WithTranslation {
  isMobile?: boolean;
  modal?: boolean;
 }
interface State { }

export const NotificationMobileIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_3107_24295" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
      <rect width="24" height="24" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#mask0_3107_24295)">
      <path d="M4 19V17H6V10C6 8.61667 6.41667 7.3875 7.25 6.3125C8.08333 5.2375 9.16667 4.53333 10.5 4.2V3.5C10.5 3.08333 10.6458 2.72917 10.9375 2.4375C11.2292 2.14583 11.5833 2 12 2C12.4167 2 12.7708 2.14583 13.0625 2.4375C13.3542 2.72917 13.5 3.08333 13.5 3.5V4.2C14.8333 4.53333 15.9167 5.2375 16.75 6.3125C17.5833 7.3875 18 8.61667 18 10V17H20V19H4ZM12 22C11.45 22 10.9792 21.8042 10.5875 21.4125C10.1958 21.0208 10 20.55 10 20H14C14 20.55 13.8042 21.0208 13.4125 21.4125C13.0208 21.8042 12.55 22 12 22ZM8 17H16V10C16 8.9 15.6083 7.95833 14.825 7.175C14.0417 6.39167 13.1 6 12 6C10.9 6 9.95833 6.39167 9.175 7.175C8.39167 7.95833 8 8.9 8 10V17Z" fill="#4B4F5E"/>
    </g>
  </svg>
);

const Wrapper = styled("div")`
  position: relative;
  cursor: pointer;
`;

const Icon = styled("div")`
   font-size: 20px;
`;

const pulse = keyframes`
  from {
    transform: scale(0.9);
  }
  to {
    transform: scale(1);
  }
`;

const Bubble = styled("div")`
  position: absolute;
  left: -50%;
  bottom: -30%;
  width: 18px;
  height: 18px;
  line-height: 18px;
  font-size: 12px;
  text-align: center;
  border-radius: 3px;
  background: ${({ theme }) => shadeAlternate(0.05, theme.colors.primary)};
  color: ${({ theme }) => theme.colors.primary_text};
  animation: ${pulse} 0.4s linear infinite;
  animation-direction: alternate-reverse;
`;

const ConnectionIndicator = styled(ConnectionIndicatorCircle)`
  position: absolute;
  left: 90%;
  top: -20%;
`;

@inject("store") @observer
export class NotificationsClass extends MobxComponent<Props, State> {

	render() {
		const { store } = this.injected;
		const { notifications } = store;
		const state = notifications.s;
		return (
			<DropDown
				width={340}
        modal={this.props.modal}
				flow="left"
				active={state.active}
				open={notifications.open}
				close={notifications.close}
				content={<NotificationsList />}>
				<Wrapper id="top-nav-notifications">
					<Icon>
						{this.props.isMobile ? <NotificationMobileIcon /> :<FaBell />}
					</Icon>
					<ConnectionIndicator status={store.ably.status} />
					{state.unseen !== 0 && <Bubble>{state.unseen}</Bubble>}
				</Wrapper>
			</DropDown>
		);
	}

}

export const Notifications = withTranslation()(NotificationsClass);
